// src/services/authService.js
import axiosInstance from "../utils/axiosInstance";
import { loginUrl, otpRequestUrl } from "../utils/urls";
import { errorHandler } from "../utils/errorHandler";

class AuthService {
  /**
   * Request OTP (Send OTP to phone/email)
   * @param {Object} values - Payload containing phoneNumber
   * @returns {Promise<Object>}
   */
  requestOtp = async (values) => {
    const response = await axiosInstance.post(otpRequestUrl, {
      ...values,
      role: "SUPER_ADMIN",
    });
    
    // Check if response is successful
    if (!response.data || response.status !== 200) {
      throw new Error("Failed to send OTP");
    }
    
    return response.data;
  };

  /**
   * Verify OTP and log user in
   * @param {Object} values - Payload containing phoneNumber and otp
   * @returns {Promise<Object>}
   */
  verifyOtp = async (values) => {
    const response = await axiosInstance.post(loginUrl, {
      ...values,
      role: "SUPER_ADMIN",
    });
    
    // Check if response is successful
    if (!response.data || response.status !== 200) {
      throw new Error("Failed to verify OTP");
    }
    
    return response.data;
  };
}

export default new AuthService();
